import React from 'react';
import { ChevronLeft } from 'lucide-react';

const AuthorHeader = ({ onBackClick }) => {
  return (
    <div className="fixed top-0 left-0 right-0 z-10 flex justify-between items-center px-4 py-2 bg-white shadow-sm">
      <div className="flex items-center">
        <button
          onClick={onBackClick}
          className="flex items-center gap-1.5 text-secondary hover:text-secondaryDark transition-colors py-1.5 px-3 rounded-md hover:bg-gray-100"
        >
          <ChevronLeft size={18} />
        </button>
        <h1 className="text-xl font-semibold text-gray-800 ml-2">Content Author</h1>
      </div>
      <div className="flex items-center">
        <img src="/capgemini-logo.png" alt="Capgemini Logo" className="h-6 w-auto object-contain" />
      </div>
    </div>
  );
};

export default AuthorHeader;